import React, {Component} from "react";
import FlexView from "react-flexview";
import {NavLink} from "react-router-dom";
import Container from "../../../../modules/commons/Container";

class DashboardKacab extends Component {
    constructor(props) {
        super(props);
    };

    createSubMenu = (val, link, icon, id) => {
        return (
            <NavLink id={id} to={link}>
                <div
                    className="content"
                    style={{
                        backgroundColor: "#E74C3C",
                        width: 235,
                        height: 235,
                        margin: 'auto',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexDirection: 'column' ,
                        borderWidth: 2,
                        borderColor: "#000000",
                        borderStyle: "solid",
                        borderRadius: 5,
                    }}
                >
                    <div
                        style={{
                            color: "#ffffff",
                        }}
                    >
                        <div className="icn" style={{margin: 10}}>
                            <i className={`${icon} fa-lg`}></i>
                        </div>
                        <div className="ttl">{val}</div>
                    </div>
                </div>
            </NavLink>
        );
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView style={{gap: "20px"}}>
                        {this.createSubMenu(
                            "Laporan Harian By Cabang",
                            "/dashboard/kacab/cabang",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_kacab_cabang"
                        )}
                        {this.createSubMenu(
                            "Laporan Harian By Team Leader",
                            "/dashboard/kacab/team-leader",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_kacab_team_leader"
                        )}
                        {this.createSubMenu(
                            "Laporan Harian By Sales",
                            "/dashboard/kacab/sales",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_kacab_sales"
                        )}
                        {this.createSubMenu(
                            "Laporan Jualan Per Tipe",
                            "/dashboard/kacab/type",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_kacab_type"
                        )}
                    </FlexView>
                    <FlexView style={{gap: "20px", marginTop: "20px"}}>
                        {this.createSubMenu(
                            "Laporan Jualan Per Tipe Per Team Leader",
                            "/dashboard/kacab/type-team-leader",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_kacab_type_team_leader"
                        )}
                        {this.createSubMenu(
                            "Laporan Sales Composition",
                            "/dashboard/kacab/sales-composition",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_kacab_sales_composition"
                        )}
                        {this.createSubMenu(
                            "Laporan Sales Structure",
                            "/dashboard/kacab/sales-structure",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_kacab_sales_structure"
                        )}
                        {this.createSubMenu(
                            "Laporan Inden",
                            "/dashboard/kacab/indent",
                            "fa fa-lg fa-tv",
                            "btn_navigate_dashboard_kacab_indent"
                        )}
                    </FlexView>
                </Container>
            </>
        )
    };

}

export default DashboardKacab;